import React from 'react';
import type { BreadcrumbItem } from '../types/common';

type BreadcrumbProps = {
  items: BreadcrumbItem[];
  className?: string;
};

const Breadcrumb = ({ items, className = '' }: BreadcrumbProps) => {
  return (
    <nav className={`dilig-breadcrumb ${className}`.trim()} aria-label="Breadcrumb">
      <ol className="dilig-breadcrumb__list">
        {items.map((item, index) => (
          <li key={index} className="dilig-breadcrumb__item">
            {item.onClick ? (
              <button
                type="button"
                className="dilig-breadcrumb__link"
                onClick={item.onClick}
              >
                {item.label}
              </button>
            ) : (
              <span className="dilig-breadcrumb__current">{item.label}</span>
            )}
            {index < items.length - 1 && (
              <span className="dilig-breadcrumb__separator" aria-hidden="true"> › </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
